import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

export const Footer = () => {
  return (
    <footer className="luxury-footer">
      <div className="footer-content">
        {/* Brand Section */}
        <div className="footer-section">
          <h2 className="footer-logo">Stories by Kalakaar</h2>
          <p className="footer-tagline">Painting love with light</p>
        </div>

        {/* Quick Links */}
        <div className="footer-section">
          <h3 className="footer-heading">Quick Links</h3>
          <nav className="footer-nav">
            <Link to="/">Home</Link>
            <Link to="/about-us">Our Story</Link>
            <Link to="/gallery">Portfolio</Link>
            <Link to="/testimonials">Testimonials</Link>
            <Link to="/contactUs">Contact</Link>
          </nav>
        </div>

        {/* Contact Information */}
        <div className="footer-section">
          <h3 className="footer-heading">Contact Us</h3>
          <div className="contact-info">
            <p>Email: hello@storiesbykalakaar.in</p>
            <p>Phone: +91 7355407103, +91 8957780465</p>
            <p>Kanpur, Uttar Pradesh</p>
          </div>
        </div>

        {/* Social Links */}
        <div className="footer-section">
          <h3 className="footer-heading">Follow Us</h3>
          <div className="social-links">
            <a href="https://www.instagram.com/kalakaarr_?igsh=b2dnMnExa244NHIz" target="_blank" rel="noopener noreferrer">Instagram</a>
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">LinkedIn</a>
            <a href="https://pinterest.com" target="_blank" rel="noopener noreferrer">Pinterest</a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-line"></div>
        <p className="copyright">© 2025 Stories by Kalakaar. All rights reserved.</p>
      </div>
    </footer>
  );
};
